import { C } from './leadOverviewCardTokens';

export const normalizeLeadConversionForCard = (lc) => {
  if (!lc) return null;
  if (lc.general_insights && typeof lc.general_insights === 'object') {
    const gi = lc.general_insights;
    let ls = gi.lead_score;
    if (ls == null) ls = gi.lead_score_base_10;
    let n = ls != null ? Number(ls) : null;
    if (n != null && !Number.isNaN(n) && gi.lead_score == null && gi.lead_score_base_10 != null && n <= 10) n *= 10;
    if (n != null && !Number.isNaN(n)) n = Math.round(Math.max(0, Math.min(100, n)));
    return {
      leadScore: n,
      dominantIntent: lc.dominant_intent ?? gi.conversion_intent,
      latestIntent: gi.conversion_intent,
      sentimentScore: gi.sentiment_score != null && gi.sentiment_score !== '' ? Math.round(Number(gi.sentiment_score)) : null,
      assessedAt: lc.assessed_at || null,
      shortNote: gi.short_important_note,
      nextBest: gi.next_best_action,
    };
  }
  const n = lc.lead_score != null ? Math.round(Number(lc.lead_score)) : null;
  return {
    leadScore: n != null && !Number.isNaN(n) ? Math.max(0, Math.min(100, n)) : null,
    dominantIntent: lc.dominant_intent ?? lc.conversion_intent,
    latestIntent: lc.conversion_intent,
    sentimentScore:
      lc.sentiment_score != null && lc.sentiment_score !== ''
        ? Math.round(Number(lc.sentiment_score))
        : null,
    assessedAt: lc.assessed_at || null,
    shortNote: lc.short_important_note,
    nextBest: lc.next_best_action,
  };
};

export const conversionIntentChipStyle = (raw) => {
  const s = String(raw || '').toLowerCase().replace(/_/g, ' ').trim();
  if (!s) return { bg: C.bg2, fg: C.slate3, bdr: C.border };
  if (s.includes('not sure') || s.includes('unsure') || s.includes('uncertain'))
    return { bg: '#FCE7F3', fg: '#9D174D', bdr: '#FBCFE8' };
  if (s.includes('not interested') || s.includes('reject') || s.includes('lost') || s.includes('cold lead'))
    return { bg: C.redLight, fg: C.redDark, bdr: '#FECACA' };
  if (s.includes('convert') || s.includes('warm') || s.includes('hot') || s.includes('positive') || s.includes('high'))
    return { bg: C.greenLight, fg: C.greenDark, bdr: '#86EFAC' };
  return { bg: C.amberLight, fg: '#92400E', bdr: '#FDE68A' };
};

/** Aligned with `lead_overview_intel._CONVERSION_BAND_HIGH` / `_CONVERSION_BAND_MEDIUM`. */
export const CONVERSION_BAND_HIGH_THRESHOLD = 68;
export const CONVERSION_BAND_MEDIUM_THRESHOLD = 38;

/** Map 0–100 score to high | medium | low (same cutoffs as backend conversion_probability_funnel). */
export const conversionBandFromScore = (score) => {
  const n = Number(score);
  if (Number.isNaN(n)) return 'medium';
  if (n >= CONVERSION_BAND_HIGH_THRESHOLD) return 'high';
  if (n >= CONVERSION_BAND_MEDIUM_THRESHOLD) return 'medium';
  return 'low';
};

export const conversionBandLabelText = (band) => {
  if (band === 'high') return 'High';
  if (band === 'low') return 'Low';
  return 'Medium';
};

export const conversionBandPalette = (band) => {
  if (band === 'high') return { fg: C.greenDark, bg: C.greenLight, bdr: '#86EFAC' };
  if (band === 'low') return { fg: C.redDark, bg: C.redLight, bdr: '#FECACA' };
  return { fg: '#92400E', bg: C.amberLight, bdr: '#FDE68A' };
};

export const conversionScoreHeroTextColor = (band) => {
  if (band === 'high') return C.tealDark;
  if (band === 'low') return C.redDark;
  return '#8B5A00';
};

export const overviewNaTypographySx = {
  fontSize: '28px',
  fontWeight: 800,
  color: C.slate4,
  letterSpacing: '0.04em',
};
